import React from 'react';
import { useSpring, animated } from '@react-spring/web';
import { createUseGesture, dragAction, pinchAction } from '@use-gesture/react';

interface DrawerProps {
  show: boolean;
  close: () => void;
  children: React.ReactNode;
}
export const Drawer: React.FC<DrawerProps> = ({ show, close, children, ...rest }) => {
  const useGesture = createUseGesture([dragAction, pinchAction]);
  const [{ y }, api] = useSpring(() => ({ x: 0, y: 0 }));
  const bind = useGesture(
    {
      onDrag: ({ down, movement: [mx, my] }) => api.start({ x: down ? mx : 0, y: down ? my : 0, immediate: down }),
      onDragEnd: ({ event, direction: [, down], ...rest }) => {
        event.preventDefault();
        if (down === -1) close();
      },
    },
    { drag: { rubberband: true } }
  );
  return (
    <animated.div {...bind()} style={{ y }} {...rest}>
      <div className="w-full flex justify-center touch-none min-h-[2rem]">
        <div className="mb-4 border-gray-300 border-2 self-center w-[2.5rem] rounded" />
      </div>
      {children}
    </animated.div>
  );
};

export default Drawer;
